// Generated automatically by nearley, version unknown
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }


// necessary to use keywords to avoid using the `reject` postprocessor which can cause poor perf
// having these as keywords removes ambiguity with `customType` rule
const keywords = [
  , "struct"
  , "module"
  , "enum"
  , "const"
  , "typedef"
  , "union"
  , "switch"
  , "case"


  //types
  , "boolean"
  , "wstring"
  , "string"
  , "sequence"

  // Boolean types
  , "TRUE"
  , "FALSE"

  // numeric types
  , "byte"
  , "octet"
  , "wchar"
  , "char"
  , "double"
  , "float"
  , "int8"
  , "uint8"
  , "int16"
  , "uint16"
  , "int32"
  , "uint32"
  , "int64"
  , "uint64"
  , "unsigned"
  , "short"
  , "long"
];

const kwObject = keywords.reduce((obj, w) => {
  obj[w] = w;
  return obj;
}, {});

const moo = require("moo");
// Terminal tokens are in all caps
const lexer = moo.compile({
  SPACE: {match: /\s+/, lineBreaks: true},
  DECIMALEXP: /(?:(?:\d+\.\d*)|(?:\d*\.\d+)|(?:[0-9]+))[eE](?:[+|-])?[0-9]+/,
  DECIMAL: /(?:(?:\d+\.\d*)|(?:\d*\.\d+))/,
  INTEGER: /0[xX][0-9a-fA-F]+|\d+/,
  COMMENT: /(?:\/\/[^\n]*)|(?:\/\*(?:.|\n)+?\*\/)/,
  STRING: {match: /"(?:\\["\\rnu]|[^"\\])*"/, value: x => x.slice(1, -1)}, // remove outside quotes
  LCBR: '{',
  RCBR: '}',
  LBR: '[',
  RBR: ']',
  LT: '<',
  GT: '>',
  LPAR: '(',
  RPAR: ')',
  ':': ':',
  ';': ';',
  ',': ',',
  AT: '@',
  PND: '#',
  PT: ".",
  '/': "/",
  SIGN: /[+-]/,
  EQ: /=[^\n]*?/,
  NAME: {match: /[a-zA-Z_][a-zA-Z0-9_]*(?:\:\:[a-zA-Z][a-zA-Z0-9_]*)*/, type: moo.keywords(kwObject)},
});

// Ignore whitespace and comment tokens
const tokensToIgnore = ['SPACE', 'COMMENT'];
// requires us to override the lexer's next function
lexer.next = (next => () => {
  let token;
  while ((token = next.call(lexer)) && tokensToIgnore.includes(token.type)) {}
  return token;
})(lexer.next);

/*** Utility functions ******/

// also used to parse tokens to strings since they start as an object
function join(d){
  return d.join("");
}

// used for combining AST components
function extend(objs) {
  return objs.filter(Boolean).reduce((r, p) => ({ ...r, ...p }), {});
}

function noop() {
  return null;
}

function getIntOrConstantValue(d) {
  const int = parseInt(d);
  if(!isNaN(int)) {
    return int;
  }

  // handle %NAME token
  return d?.value ? {usesConstant: true, name: d.value} : undefined;
}

var grammar = {
    Lexer: lexer,
    ParserRules: [
    {"name": "main$ebnf$1$subexpression$1$ebnf$1", "symbols": []},
    {"name": "main$ebnf$1$subexpression$1$ebnf$1", "symbols": ["main$ebnf$1$subexpression$1$ebnf$1", "importDcl"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main$ebnf$1$subexpression$1", "symbols": ["main$ebnf$1$subexpression$1$ebnf$1", "definition"]},
    {"name": "main$ebnf$1", "symbols": ["main$ebnf$1$subexpression$1"]},
    {"name": "main$ebnf$1$subexpression$2$ebnf$1", "symbols": []},
    {"name": "main$ebnf$1$subexpression$2$ebnf$1", "symbols": ["main$ebnf$1$subexpression$2$ebnf$1", "importDcl"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main$ebnf$1$subexpression$2", "symbols": ["main$ebnf$1$subexpression$2$ebnf$1", "definition"]},
    {"name": "main$ebnf$1", "symbols": ["main$ebnf$1", "main$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "main", "symbols": ["main$ebnf$1"], "postprocess":  d => {
          return d[0].flatMap(inner => inner[1]);
        }
        },
    {"name": "importDcl$subexpression$1", "symbols": [(lexer.has("STRING") ? {type: "STRING"} : STRING)]},
    {"name": "importDcl$subexpression$1$ebnf$1", "symbols": []},
    {"name": "importDcl$subexpression$1$ebnf$1$subexpression$1", "symbols": [{"literal":"/"}, (lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "importDcl$subexpression$1$ebnf$1", "symbols": ["importDcl$subexpression$1$ebnf$1", "importDcl$subexpression$1$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "importDcl$subexpression$1", "symbols": [{"literal":"<"}, (lexer.has("NAME") ? {type: "NAME"} : NAME), "importDcl$subexpression$1$ebnf$1", {"literal":"."}, {"literal":"idl"}, {"literal":">"}]},
    {"name": "importDcl", "symbols": [{"literal":"#"}, {"literal":"include"}, "importDcl$subexpression$1"], "postprocess": noop},
    {"name": "moduleDcl$ebnf$1$subexpression$1", "symbols": ["definition"]},
    {"name": "moduleDcl$ebnf$1", "symbols": ["moduleDcl$ebnf$1$subexpression$1"]},
    {"name": "moduleDcl$ebnf$1$subexpression$2", "symbols": ["definition"]},
    {"name": "moduleDcl$ebnf$1", "symbols": ["moduleDcl$ebnf$1", "moduleDcl$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "moduleDcl", "symbols": [{"literal":"module"}, "fieldName", {"literal":"{"}, "moduleDcl$ebnf$1", {"literal":"}"}], "postprocess": 
        function processModule(d) {
          const moduleName = d[1].name;
          const defs = d[3];
          // need to return array here to keep same signature as processComplexModule
          return {
            declarator: "module",
            name: moduleName,
            definitions: defs.flat(1),
          };
        }
        },
    {"name": "definition$subexpression$1", "symbols": ["typeDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["constantDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["moduleDcl"]},
    {"name": "definition$subexpression$1", "symbols": ["union"]},
    {"name": "definition", "symbols": ["multiAnnotations", "definition$subexpression$1", "semi"], "postprocess":  d => {
          const annotations = d[0];
          const declaration = d[1][0];
          return extend([annotations, declaration]);
        }},
    {"name": "typeDcl$subexpression$1", "symbols": ["struct"]},
    {"name": "typeDcl$subexpression$1", "symbols": ["typedef"]},
    {"name": "typeDcl$subexpression$1", "symbols": ["enum"]},
    {"name": "typeDcl", "symbols": ["typeDcl$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "union", "symbols": [{"literal":"union"}, "fieldName", {"literal":"switch"}, {"literal":"("}, "switchTypedef", {"literal":")"}, {"literal":"{"}, "switchBody", {"literal":"}"}], "postprocess": 
        (d) => {
        const name = d[1].name
        const switchType = d[4].type;
        const switchBody = d[7];
        const allCases = switchBody;
        const defaultCase = allCases.find(c => "default" in c);
        const cases = allCases.filter(c => ("predicates" in c));
        const unionNode = {
          declarator: "union",
          name,
          switchType,
          cases,
        };
        if(defaultCase) {
          unionNode.defaultCase = defaultCase.default;
        }
        return unionNode;
        }
        },
    {"name": "switchTypedef$subexpression$1", "symbols": ["customType"]},
    {"name": "switchTypedef$subexpression$1", "symbols": ["numericType"]},
    {"name": "switchTypedef$subexpression$1", "symbols": ["booleanType"]},
    {"name": "switchTypedef", "symbols": ["switchTypedef$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "switchBody$ebnf$1", "symbols": ["case"]},
    {"name": "switchBody$ebnf$1", "symbols": ["switchBody$ebnf$1", "case"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "switchBody", "symbols": ["switchBody$ebnf$1"], "postprocess": d => d.flat(2)},
    {"name": "case$ebnf$1", "symbols": ["caseLabel"]},
    {"name": "case$ebnf$1", "symbols": ["case$ebnf$1", "caseLabel"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "case", "symbols": ["case$ebnf$1", "elementSpec", {"literal":";"}], "postprocess":  d => {
          const cases = d[0];
          const type = d[1]
          const nonDefaultCases = cases.filter(casePredicate => casePredicate !== "default");
          const isDefault = cases.length !== nonDefaultCases.length;
          const caseArray = []
          if(isDefault) {
            caseArray.push({default: type});
          }
          if(nonDefaultCases.length > 0) {
            caseArray.push({
              predicates: nonDefaultCases,
              type,
            });
          }
          return caseArray;
        }},
    {"name": "caseLabel$subexpression$1", "symbols": [{"literal":"case"}, "constExpression", {"literal":":"}]},
    {"name": "caseLabel", "symbols": ["caseLabel$subexpression$1"], "postprocess": (d) => d[0][1]},
    {"name": "caseLabel$subexpression$2", "symbols": [{"literal":"default"}, {"literal":":"}]},
    {"name": "caseLabel", "symbols": ["caseLabel$subexpression$2"], "postprocess": () => "default"},
    {"name": "elementSpec", "symbols": ["typeDeclaratorWithAnnotations"], "postprocess": d => d[0]},
    {"name": "enum$ebnf$1", "symbols": []},
    {"name": "enum$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "enumFieldName"]},
    {"name": "enum$ebnf$1", "symbols": ["enum$ebnf$1", "enum$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "enum", "symbols": [{"literal":"enum"}, "fieldName", {"literal":"{"}, "enumFieldName", "enum$ebnf$1", {"literal":"}"}], "postprocess":  d => {
          const name = d[1].name;
          const firstMember = d[3];
          const members = d[4]
            .flat(2)
            // need to filter out commas
            .filter(item => Boolean(item) && item.type !== ",");
        
          return {
            declarator: 'enum',
            name,
            enumerators: [firstMember, ...members],
          };
        } },
    {"name": "enumFieldName", "symbols": ["multiAnnotations", "fieldName"], "postprocess":  d => {
          const annotations = d[0];
          const name = d[1];
          return extend([annotations, name]);
        } },
    {"name": "struct$ebnf$1", "symbols": []},
    {"name": "struct$ebnf$1$subexpression$1", "symbols": ["member"]},
    {"name": "struct$ebnf$1", "symbols": ["struct$ebnf$1", "struct$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "struct", "symbols": [{"literal":"struct"}, "fieldName", {"literal":"{"}, "struct$ebnf$1", {"literal":"}"}], "postprocess":  d => {
          const name = d[1].name;
          const definitions = d[3].flat(2).filter(def => def !== null);
          return {
            declarator: 'struct',
            name,
            definitions,
          };
        } },
    {"name": "typedef", "symbols": [{"literal":"typedef"}, "typeDeclarator"], "postprocess":  ([_, definition]) => (
          { declarator: "typedef", ...definition }
        )},
    {"name": "typeDeclaratorWithAnnotations", "symbols": ["multiAnnotations", "typeDeclarator"], "postprocess":  d => {
          const annotations = d[0];
          const definition = d[1];
          return extend([annotations, definition]);
        } },
    {"name": "typeDeclarator$subexpression$1", "symbols": ["allTypes", "fieldName", "arrayLengths"]},
    {"name": "typeDeclarator$subexpression$1", "symbols": ["allTypes", "fieldName"]},
    {"name": "typeDeclarator$subexpression$1", "symbols": ["sequenceType", "fieldName"]},
    {"name": "typeDeclarator", "symbols": ["typeDeclarator$subexpression$1"], "postprocess": d => extend(d[0])},
    {"name": "constantDcl", "symbols": ["constType"], "postprocess": d => d[0]},
    {"name": "member", "symbols": ["fieldWithAnnotation", "semi"], "postprocess": d => d[0]},
    {"name": "fieldWithAnnotation", "symbols": ["multiAnnotations", "fieldDcl"], "postprocess":  d=> {
          
          const annotations = d[0]
          const fields = d[1];
          const finalDefs = fields.map((def) =>
            extend([annotations, def])
          );
          return finalDefs;
        } },
    {"name": "fieldDcl$subexpression$1", "symbols": ["allTypes", "multiFieldNames", "arrayLengths"]},
    {"name": "fieldDcl$subexpression$1", "symbols": ["allTypes", "multiFieldNames"]},
    {"name": "fieldDcl$subexpression$1", "symbols": ["sequenceType", "multiFieldNames"]},
    {"name": "fieldDcl", "symbols": ["fieldDcl$subexpression$1"], "postprocess":  (d) => {
          const names = d[0].splice(1, 1)[0];
          // create a definition for each name
          const defs = names.map((nameObj) => ({
            ...extend([...d[0], nameObj]),
            declarator: "struct-member"
          }));
          return defs;
        } },
    {"name": "multiFieldNames$ebnf$1", "symbols": []},
    {"name": "multiFieldNames$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "fieldName"]},
    {"name": "multiFieldNames$ebnf$1", "symbols": ["multiFieldNames$ebnf$1", "multiFieldNames$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multiFieldNames", "symbols": ["fieldName", "multiFieldNames$ebnf$1"], "postprocess": 
        d => {
          const fieldNames = d.flat(2).filter( d => d !== null && d.name);
          return fieldNames;
        } },
    {"name": "multiAnnotations$ebnf$1", "symbols": []},
    {"name": "multiAnnotations$ebnf$1", "symbols": ["multiAnnotations$ebnf$1", "annotation"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multiAnnotations", "symbols": ["multiAnnotations$ebnf$1"], "postprocess": 
        d => {
          return d[0].length > 0 ? {annotations: d[0].reduce((record, annotation) => {
            record[annotation.name] = annotation;
            return record;
          }, {}) } : null;
        }
        },
    {"name": "annotation$ebnf$1$subexpression$1", "symbols": [{"literal":"("}, "annotationParams", {"literal":")"}]},
    {"name": "annotation$ebnf$1", "symbols": ["annotation$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "annotation$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "annotation", "symbols": ["at", (lexer.has("NAME") ? {type: "NAME"} : NAME), "annotation$ebnf$1"], "postprocess":  d => {
          const annotationName = d[1].value;
          const params = d[2] ? d[2][1] : undefined;
          if(params == undefined) {
            return { type: 'no-params', name: annotationName };
          }
          // named params in the form of [{<name>: <value>}, ...]
          if(Array.isArray(params)) {
            const namedParamsRecord = extend(params);
            return {
              type: 'named-params',
              name: annotationName,
              namedParams: namedParamsRecord
            };
          }
        
          // can only be constant param
          return { type: "const-param", value: params, name: annotationName };
        } },
    {"name": "annotationParams$subexpression$1", "symbols": ["multipleNamedAnnotationParams"]},
    {"name": "annotationParams$subexpression$1", "symbols": ["constExpression"]},
    {"name": "annotationParams", "symbols": ["annotationParams$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "multipleNamedAnnotationParams$ebnf$1", "symbols": []},
    {"name": "multipleNamedAnnotationParams$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "namedAnnotationParam"]},
    {"name": "multipleNamedAnnotationParams$ebnf$1", "symbols": ["multipleNamedAnnotationParams$ebnf$1", "multipleNamedAnnotationParams$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "multipleNamedAnnotationParams", "symbols": ["namedAnnotationParam", "multipleNamedAnnotationParams$ebnf$1"], "postprocess": 
        d => ([d[0], ...d[1].flatMap(([, param]) => param)]) // returns array
        },
    {"name": "constExpression", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  d => 
        // should match `variableAssignment` constant usage structure for consistency
        // between named and const annotation types
        ({usesConstant: true, name: d[0].value})
        },
    {"name": "constExpression", "symbols": ["literal"], "postprocess": d => d[0].value},
    {"name": "namedAnnotationParam$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME), "assignment"]},
    {"name": "namedAnnotationParam", "symbols": ["namedAnnotationParam$subexpression$1"], "postprocess": d => ({[d[0][0].value]: d[0][1].value})},
    {"name": "at", "symbols": [{"literal":"@"}], "postprocess": noop},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "numericType", "fieldName", "floatAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "numericType", "fieldName", "intAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "stringType", "fieldName", "stringAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "booleanType", "fieldName", "booleanAssignment", "simple"]},
    {"name": "constType$subexpression$1", "symbols": ["constKeyword", "customType", "fieldName", "variableAssignment", "simple"]},
    {"name": "constType", "symbols": ["constType$subexpression$1"], "postprocess":  d => {
          return extend(d[0]);
        } },
    {"name": "constKeyword", "symbols": [{"literal":"const"}], "postprocess": d => ({isConstant: true, declarator: "const"})},
    {"name": "fieldName", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess": d => ({name: d[0].value})},
    {"name": "sequenceType$ebnf$1$subexpression$1$subexpression$1", "symbols": ["INT"]},
    {"name": "sequenceType$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "sequenceType$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "sequenceType$ebnf$1$subexpression$1$subexpression$1"]},
    {"name": "sequenceType$ebnf$1", "symbols": ["sequenceType$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "sequenceType$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "sequenceType", "symbols": [{"literal":"sequence"}, {"literal":"<"}, "allTypes", "sequenceType$ebnf$1", {"literal":">"}], "postprocess":  d => {
          const arrayUpperBound = d[3] !== null ? getIntOrConstantValue(d[3][1][0]) : undefined;
          const typeObj = d[2];
          return {
            ...typeObj,
            isArray: true,
            arrayUpperBound,
          };
        }},
    {"name": "arrayLengths$ebnf$1", "symbols": ["arrayLength"]},
    {"name": "arrayLengths$ebnf$1", "symbols": ["arrayLengths$ebnf$1", "arrayLength"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "arrayLengths", "symbols": ["arrayLengths$ebnf$1"], "postprocess": 
        (d) => {
          const arrInfo = {isArray: true};
          const arrLengthList = d.flat(2).filter((num) => num != undefined);
          arrInfo.arrayLengths = arrLengthList;
          return arrInfo;
        }
        },
    {"name": "arrayLength$subexpression$1", "symbols": ["INT"]},
    {"name": "arrayLength$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "arrayLength", "symbols": [{"literal":"["}, "arrayLength$subexpression$1", {"literal":"]"}], "postprocess": 
        ([, intOrName]) => (getIntOrConstantValue(intOrName ? intOrName[0] : undefined))
        },
    {"name": "assignment$subexpression$1", "symbols": ["floatAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["intAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["stringAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["booleanAssignment"]},
    {"name": "assignment$subexpression$1", "symbols": ["variableAssignment"]},
    {"name": "assignment", "symbols": ["assignment$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "floatAssignment$subexpression$1", "symbols": ["SIGNED_FLOAT"]},
    {"name": "floatAssignment$subexpression$1", "symbols": ["FLOAT"]},
    {"name": "floatAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "floatAssignment$subexpression$1"], "postprocess": ([, num]) => ({valueText: num[0], value: parseFloat(num[0])})},
    {"name": "intAssignment$subexpression$1", "symbols": ["SIGNED_INT"]},
    {"name": "intAssignment$subexpression$1", "symbols": ["INT"]},
    {"name": "intAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "intAssignment$subexpression$1"], "postprocess": ([, num]) => ({valueText: num[0], value: parseInt(num[0])})},
    {"name": "stringAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "STR"], "postprocess": ([, str]) => ({valueText: str, value: str})},
    {"name": "booleanAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), "BOOLEAN"], "postprocess": ([, bool]) => ({valueText: bool, value: bool === "TRUE"})},
    {"name": "variableAssignment", "symbols": [(lexer.has("EQ") ? {type: "EQ"} : EQ), (lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  ([, name]) => 
        ({
          valueText: name.value,
          value: {
            usesConstant: true,
            name: name.value
          }
        })
        },
    {"name": "allTypes$subexpression$1", "symbols": ["primitiveTypes"]},
    {"name": "allTypes$subexpression$1", "symbols": ["customType"]},
    {"name": "allTypes", "symbols": ["allTypes$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["stringType"]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["numericType"]},
    {"name": "primitiveTypes$subexpression$1", "symbols": ["booleanType"]},
    {"name": "primitiveTypes", "symbols": ["primitiveTypes$subexpression$1"], "postprocess": d => ({...d[0][0], isComplex: false})},
    {"name": "customType", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)], "postprocess":  d => {
          const typeName = d[0].value;
        
          // post process will go through and replace typedefs with their actual type
          return {type: typeName };
        }},
    {"name": "stringType$subexpression$1", "symbols": [{"literal":"string"}]},
    {"name": "stringType$subexpression$1", "symbols": [{"literal":"wstring"}]},
    {"name": "stringType$ebnf$1$subexpression$1$subexpression$1", "symbols": ["INT"]},
    {"name": "stringType$ebnf$1$subexpression$1$subexpression$1", "symbols": [(lexer.has("NAME") ? {type: "NAME"} : NAME)]},
    {"name": "stringType$ebnf$1$subexpression$1", "symbols": [{"literal":"<"}, "stringType$ebnf$1$subexpression$1$subexpression$1", {"literal":">"}]},
    {"name": "stringType$ebnf$1", "symbols": ["stringType$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "stringType$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "stringType", "symbols": ["stringType$subexpression$1", "stringType$ebnf$1"], "postprocess":  d => {
          const stringKind = d[0][0].value;
          let strLength = undefined;
          if(d[1] !== null) {
            strLength = getIntOrConstantValue(d[1][1] ? d[1][1][0] : undefined);
          }
          return {type: stringKind, upperBound: strLength};
        } },
    {"name": "booleanType", "symbols": [{"literal":"boolean"}], "postprocess": d => ({type: "bool"})},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"byte"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"octet"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"wchar"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"char"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}, {"literal":"double"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"double"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"float"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint8"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint16"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint32"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"int64"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"uint64"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"short"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"short"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"long"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"unsigned"}, {"literal":"long"}]},
    {"name": "numericType$subexpression$1", "symbols": [{"literal":"long"}]},
    {"name": "numericType", "symbols": ["numericType$subexpression$1"], "postprocess":  (d) => {
          const typeString = d[0].map((t) => t?.value).filter(t => !!t).join(" ");
          return { type: typeString };
        }
        },
    {"name": "literal$subexpression$1", "symbols": ["booleanLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["strLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["floatLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["intLiteral"]},
    {"name": "literal", "symbols": ["literal$subexpression$1"], "postprocess": d => d[0][0]},
    {"name": "booleanLiteral", "symbols": ["BOOLEAN"], "postprocess": d => ({value: d[0] === "TRUE"})},
    {"name": "strLiteral", "symbols": ["STR"], "postprocess": d => ({value: d[0]})},
    {"name": "floatLiteral$subexpression$1", "symbols": ["SIGNED_FLOAT"]},
    {"name": "floatLiteral$subexpression$1", "symbols": ["FLOAT"]},
    {"name": "floatLiteral", "symbols": ["floatLiteral$subexpression$1"], "postprocess": d => ({value: parseFloat(d[0][0])})},
    {"name": "intLiteral$subexpression$1", "symbols": ["SIGNED_INT"]},
    {"name": "intLiteral$subexpression$1", "symbols": ["INT"]},
    {"name": "intLiteral", "symbols": ["intLiteral$subexpression$1"], "postprocess": d => ({value: parseInt(d[0][0])})},
    {"name": "BOOLEAN$subexpression$1", "symbols": [{"literal":"TRUE"}]},
    {"name": "BOOLEAN$subexpression$1", "symbols": [{"literal":"FALSE"}]},
    {"name": "BOOLEAN", "symbols": ["BOOLEAN$subexpression$1"], "postprocess": join},
    {"name": "STR$ebnf$1", "symbols": [(lexer.has("STRING") ? {type: "STRING"} : STRING)]},
    {"name": "STR$ebnf$1", "symbols": ["STR$ebnf$1", (lexer.has("STRING") ? {type: "STRING"} : STRING)], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "STR", "symbols": ["STR$ebnf$1"], "postprocess":  d => {
          return join(d.flat(1).filter(d => d !== null));
        }},
    {"name": "SIGNED_FLOAT$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "SIGNED_FLOAT$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "SIGNED_FLOAT", "symbols": ["SIGNED_FLOAT$subexpression$1", "FLOAT"], "postprocess": join},
    {"name": "FLOAT$subexpression$1", "symbols": [(lexer.has("DECIMAL") ? {type: "DECIMAL"} : DECIMAL)]},
    {"name": "FLOAT$subexpression$1", "symbols": [(lexer.has("DECIMALEXP") ? {type: "DECIMALEXP"} : DECIMALEXP)]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$1"], "postprocess": join},
    {"name": "FLOAT$subexpression$2", "symbols": [(lexer.has("DECIMAL") ? {type: "DECIMAL"} : DECIMAL), {"literal":"d"}]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$2"], "postprocess": d => d[0][0].value},
    {"name": "FLOAT$subexpression$3", "symbols": ["INT", {"literal":"d"}]},
    {"name": "FLOAT", "symbols": ["FLOAT$subexpression$3"], "postprocess": d => d[0][0]},
    {"name": "SIGNED_INT$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "SIGNED_INT$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "SIGNED_INT", "symbols": ["SIGNED_INT$subexpression$1", "INT"], "postprocess": join},
    {"name": "INT", "symbols": [(lexer.has("INTEGER") ? {type: "INTEGER"} : INTEGER)], "postprocess": join},
    {"name": "semi", "symbols": [{"literal":";"}], "postprocess": noop},
    {"name": "simple", "symbols": [], "postprocess": () => ({isComplex: false})}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.grammar = grammar;
}
})();
